<button mat-raised-button routerLink="/schedules/routes">All Routes</button>
<div class="container">
    <app-route-display *ngIf="route" [route]="route"></app-route-display>
    <mat-spinner *ngIf="!route"></mat-spinner>
</div>